import { Injectable } from '@angular/core';
import Tesseract from 'tesseract.js';
import imageCompression from 'browser-image-compression';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  constructor() {
    // Empty constructor
  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  async compressImage(file: File, max_size_mb = 1): Promise<File> {
    console.log('Compressing image:', file);
    const options = {
      maxSizeMB: max_size_mb,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      console.log('Compressed image:', compressedFile);
      return compressedFile;
    } catch (error) {
      console.error('Error compressing image:', error);
      throw error;
    }
  }

  async extractTextFromImageTesseract(
    base64Image: string,
    clean = true
  ): Promise<string> {
    try {
      const {
        data: { text },
      } = await Tesseract.recognize(base64Image, 'eng');
      if (clean) {
        return this.cleanText(text);
      }
      return text;
    } catch (error) {
      console.error('Error extracting text from image:', error);
      throw error;
    }
  }

  private cleanText(text: string): string {
    return text.trim().replace(/\s+/g, ' ');
  }
}
